import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { 
    IonModal, IonContent, IonIcon
} from '@ionic/angular/standalone';

import { SlideFromRight } from '@marv/animations';
import { MarvModalService } from '@marv/services';

@Component({
    selector: 'marv-drawer',
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.scss'],
    imports: [IonModal, IonContent, IonIcon]
})
export class MarvDrawerComponent  implements OnInit {

    @Input({alias : 'showBackdrop', required : false}) showBackdrop: boolean = true;
    @Input({alias : 'showCloseButton', required : false}) showCloseButton: boolean = true;
    @Input({alias : 'backdropDismiss', required : false}) backdropDismiss: boolean = true;
    @Input({alias : 'canDismiss', required : false}) canDismissDrawer: any = () => true;
    @Input({alias : 'size', required : false}) sizeDrawer: 'big'|'medium'|'small' = 'medium';
    @Input({alias : 'noPadding', required : false}) noPadding: boolean = false;
    @Input({alias : 'hide', required : false}) hideDrawer: boolean = false;
    @Output() onDidDismiss = new EventEmitter<any>();
   
    @ViewChild('modalDrawer') modalDrawer: IonModal;
    
    constructor(        
        public slideFromRight: SlideFromRight,
        private marvModalService: MarvModalService
    ) { }

    ngOnInit() {}
    
    open(){        
        this.marvModalService.open(this.modalDrawer);
    }
    
    async close(resetDrawer: boolean = true){
        await this.modalDrawer.dismiss({resetDrawer: resetDrawer});
    }
    
    async canDismissModal(data?: any, role?: string) {
        return role !== 'gesture' && this.canDismissDrawer();
    }
    
    onDidDismissModal($event: any) {
        if(typeof $event.detail.data?.resetDrawer === 'undefined'){
            if(typeof $event.detail.data === 'undefined'){
                $event.detail.data = {};
            }
            $event.detail.data.resetDrawer = true;
        }
        
        this.marvModalService.onDidDismiss($event); 
        
        this.onDidDismiss.emit($event);
    }    
    
}
